// Generated by ts-to-zod
import { z } from 'zod';

export const resetPayloadSchema = z.object({
  email: z.string(),
});
